import { isRecord } from "./is-record";
export type PlayerType = "file" | "container" | "human";

function obj(value: unknown): Record<string, unknown> {
  return isRecord(value) ? value : {};
}

/** Resolve supported seats from one runtime or a runtime list. */
export function coworldPlayerTypes(manifest: unknown): PlayerType[] {
  const game = obj(obj(manifest).game);
  const runtimes = Array.isArray(game.player_runtime)
    ? game.player_runtime
    : [
        game.player_runtime === "game-hosted"
          ? "game-hosted"
          : "platform-hosted",
      ];
  const types: PlayerType[] = [];

  if (runtimes.includes("game-hosted")) types.push("file");

  if (runtimes.includes("platform-hosted")) {
    types.push("container", "human");
  } else if (
    runtimes.includes("game-hosted") &&
    obj(obj(game.runnable).env).COGAME_PLAY_SEATS_SCHEMA ===
      "coworld-play-seats/1"
  ) {
    types.push("human");
  }

  return types;
}
